import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { TopUpTransactionModel } from "../../models/top-up-transaction.model";
import { MultipleOpsResult } from "@/core/models/response.model";

interface _TopUpTransactionGetParams {
    search?: string;
}

@injectable()
export class TopUpTransactionRepo extends TableRepo<TopUpTransactionModel> {
    constructor() {
        super("/api/TopUpTransaction");
    }

    async getData(index: number, params: _TopUpTransactionGetParams, pageSize = 10): Promise<ApiPage<TopUpTransactionModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async cancelMany(models: TopUpTransactionModel[]): Promise<MultipleOpsResult> {
        let success = 0;
        const responses = await Promise.all(models.map(model => this.apiRepo.post(`${this.basepath}/cancel`, {id: model.id})));
        responses.forEach(response => {
            if (response?.code === '00') {
                success++;
            }
        })
        if (success > 0) {
            this.changes.next(Date.now());
        }
        return {success, total: models.length};
    }

    async getQR(model: TopUpTransactionModel): Promise<string> {
        try {
            const response = await this.apiRepo.get<string>(`${this.basepath}/get-qr`, {id: model.id});
            if (response?.code === '00') {
                return response.result
            };
        } catch (err) {
            console.log(err);
        }
        return "";
    }
}